module.exports = __webpack_public_path__ + "static/media/www.babylonhki.fi.f29d6072.png";